<template>
    <div class="bg-white shadow-md rounded-xl p-4 w-full flex flex-col justify-between">
        <!-- Header Section -->
        <div class="flex justify-between items-center">
            <p class="text-gray-900 font-semibold text-lg">Consulting Hours</p>
            <select v-model="selectedMonthOption" @change="handleSelectMonthOption"
                class="bg-gray-100 text-gray-700 text-sm border border-gray-200 px-2 py-1 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-400">
                <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
            </select>
        </div>

        <!-- Main Value Section -->
        <div class="flex justify-between items-center">
            <div class="mt-4">
                <div v-if="loading" class="animate-pulse h-8 w-32 bg-gray-200 rounded mb-2"></div>
                <p v-else class="text-3xl font-bold text-gray-900">
                    {{ counthours }}
                    <span class="text-green-500 text-sm inline-flex items-center ml-2">
                        ↑ 8%
                    </span>
                </p>
                <p class="small-p-text mt-1">increased than last week</p>
            </div>

            <!-- Image Instead of Chart -->
            <div class="mt-4 flex justify-end">
                <img src="@/assets/chart-placeholder.png" alt="Consulting Chart" class="w-20 h-auto" />
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../../../router/api";

export default {
    data() {
        return {
            counthours: "0",
            loading: true,
            selectedMonthOption: "",
            months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        };
    },
    methods: {
        handleSelectMonthOption() {
            this.loading = true;
            Api.getAdminConsultingHours(this.selectedMonthOption)
                .then((res) => {
                    this.counthours = res.data.admin_consulting_hours;
                    this.loading = false;
                })
                .catch((err) => {
                    console.error("Error fetching consulting hours:", err);
                    this.counthours = "0";
                    this.loading = false;
                });
        },
    },
    mounted() {
        // Set current month as default
        const currentDate = new Date();
        this.selectedMonthOption = this.months[currentDate.getMonth()];
        this.handleSelectMonthOption();
    },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/dashboard1/ConsultingHours.vue